/*
    定义系统常量和枚举
    减少频繁服务器调用
*/
export default {
    // 字典
    syscode:{
        // 公司注册地
        RegisteredRegion :  [
            {"code":"01","name":"浦东新区"},{"code":"02","name":"闵行区"},{"code":"03","name":"松江区"},{"code":"04","name":"宝山区"},{"code":"05","name":"嘉定区"},{"code":"06","name":"徐汇区"},{"code":"07","name":"青浦区"},{"code":"08","name":"静安区"},{"code":"09","name":"普陀区"},{"code":"10","name":"杨浦区"},{"code":"11","name":"奉贤区"},{"code":"12","name":"黄浦区"},{"code":"13","name":"虹口区"},{"code":"14","name":"长宁区"},{"code":"15","name":"金山区"},{"code":"16","name":"崇明区"}
        ],
        // 政治面貌
        PoliticalStatus : [
            {"code":"01","name":"党员"},{"code":"02","name":"团员"},{"code":"04","name":"其他民主党派"},{"code":"03","name":"群众"}
        ],
        // 职称
        Title : [
            {"code":"00","name":"无"},{"code":"01","name":"初级"},{"code":"02","name":"中级"},{"code":"03","name":"高级"}
        ],
        // 学历
        Education : [
            {"code":"4","name":"中专及以下"},{"code":"5","name":"大专"},{"code":"6","name":"本科"},{"code":"7","name":"硕士研究生"},{"code":"8","name":"博士研究生"}
        ],
        // 职业
        Profession : [
            {"code":"01","name":"公务员（含参公）"},{"code":"02","name":"教师"},{"code":"03","name":"医务人员"},{"code":"04","name":"科研院所职工"},{"code":"08","name":"消防救援职工"},{"code":"09","name":"其他事业单位职工"},{"code":"10","name":"在职军官"},{"code":"05","name":"市容环卫企业职工"},{"code":"06","name":"公交、轨道交通企业职工"},{"code":"11","name":"家政企业职工"},{"code":"12","name":"邮政、快递、送餐企业职工"},{"code":"13","name":"绿化园林类企业职工"},{"code":"14","name":"市政养护类企业职工"},{"code":"15","name":"应急保障类企业职工"},{"code":"16","name":"水务、电力、燃气等公用事业"},{"code":"17","name":"企业职工"},{"code":"18","name":"民航、铁路、出租汽车等大交通企业职工"},{"code":"19","name":"物业企业职工"},{"code":"20","name":"医疗辅助类企业职工"},{"code":"21","name":"养老照护类企业职工"},{"code":"22","name":"保安保洁类企业职工"},{"code":"07","name":"其它"}
        ],
        // 户口性质
        IdentityType : [
            {"code":"01","name":"本市常住户口"},{"code":"03","name":"本市集体户口"},{"code":"02","name":"非本市户口"}
        ],
        // 民族
        Nation : [
            {"code":"1","name":"汉族"},{"code":"2","name":"蒙古族"},{"code":"3","name":"回族"},{"code":"4","name":"藏族"},{"code":"5","name":"维吾尔族"},{"code":"6","name":"苗族"},{"code":"7","name":"彝族"},{"code":"8","name":"壮族"},{"code":"9","name":"布依族"},{"code":"10","name":"朝鲜族"},{"code":"11","name":"满族"},{"code":"12","name":"侗族"},{"code":"13","name":"瑶族"},{"code":"14","name":"白族"},{"code":"15","name":"土家族"},{"code":"16","name":"哈尼族"},{"code":"17","name":"哈萨克族"},{"code":"18","name":"傣族"},{"code":"19","name":"黎族"},{"code":"20","name":"傈僳族"},{"code":"21","name":"佤族"},{"code":"22","name":"畲族"},{"code":"23","name":"高山族"},{"code":"24","name":"拉祜族"},{"code":"25","name":"水族"},{"code":"26","name":"东乡族"},{"code":"27","name":"纳西族"},{"code":"28","name":"景颇族"},{"code":"29","name":"柯尔克孜族"},{"code":"30","name":"土族"},{"code":"31","name":"达斡尔族"},{"code":"32","name":"仫佬族"},{"code":"33","name":"羌族"},{"code":"34","name":"布朗族"},{"code":"35","name":"撒拉族"},{"code":"36","name":"毛难族"},{"code":"37","name":"仡佬族"},{"code":"38","name":"锡伯族"},{"code":"39","name":"阿昌族"},{"code":"40","name":"普米族"},{"code":"41","name":"塔吉克族"},{"code":"42","name":"怒族"},{"code":"43","name":"乌孜别克族"},{"code":"44","name":"俄罗斯族"},{"code":"45","name":"鄂温克族"},{"code":"46","name":"崩龙族"},{"code":"47","name":"保安族"},{"code":"48","name":"裕固族"},{"code":"49","name":"京族"},{"code":"50","name":"塔塔尔族"},{"code":"51","name":"独龙族"},{"code":"52","name":"鄂伦春族"},{"code":"53","name":"赫哲族"},{"code":"54","name":"门巴族"},{"code":"55","name":"珞巴族"},{"code":"56","name":"基诺族"},{"code":"57","name":"无"}
        ],
        // 街镇
        StreetTownList : [
            {"code":"11","name":"嘉定新城（马陆镇）"},{"code":"12","name":"新成路街道"},{"code":"13","name":"外冈镇"},{"code":"14","name":"徐行镇"},{"code":"15","name":"真新街道"},{"code":"16","name":"南翔镇"},{"code":"17","name":"江桥镇"},{"code":"18","name":"嘉定工业区"},{"code":"19","name":"嘉定镇街道"},{"code":"20","name":"安亭镇"},{"code":"21","name":"华亭镇"},{"code":"22","name":"菊园新区"}
        ],
        // 银行
        BankType : [
            {"code":"5","name":"交通银行"},{"code":"2","name":"农业银行"},{"code":"3","name":"建设银行"},{"code":"4","name":"中国银行"},{"code":"1","name":"工商银行"},{"code":"6","name":"招商银行"},{"code":"7","name":"中信银行"},{"code":"8","name":"上海浦东发展银行"},{"code":"20","name":"上海银行"},{"code":"19","name":"上海农商银行"},{"code":"11","name":"汇丰银行"},{"code":"12","name":"渣打"},{"code":"13","name":"光大银行"},{"code":"14","name":"邮政储蓄"},{"code":"15","name":"江苏银行"},{"code":"16","name":"宁波银行"},{"code":"17","name":"浙江泰隆银行"},{"code":"18","name":"广发银行"},{"code":"21","name":"中信银行"},{"code":"9","name":"民生银行"},{"code":"10","name":"未提供银行账号"},{"code":"22","name":"兴业银行"},{"code":"23","name":"天津银行"},{"code":"24","name":"平安银行"},{"code":"25","name":"南江银行"}
        ],
    },


    // 枚举
    enum:{
        // 证件类型
        CertType: [
            {"enumValue":0,"enumText":"身份证"},{"enumValue":1,"enumText":"护照"}
        ],
        // 婚姻状况
        MaritalStatus : [
            {"enumValue":0,"enumText":"未婚"},{"enumValue":1,"enumText":"已婚"},{"enumValue":2,"enumText":"离异"},{"enumValue":3,"enumText":"丧偶"}
        ],
        // 关系
        RelationPrincipal : [
            {"enumValue":0,"enumText":"配偶"},{"enumValue":1,"enumText":"子女"},{"enumValue":3,"enumText":"父母"},{"enumValue":4,"enumText":"其他"}
        ],
        // 性别
        AllowSex : [
            {"enumValue":0,"enumText":"女"},{"enumValue":1,"enumText":"男"},{"enumValue":2,"enumText":"不限"}
        ],
        // 租赁类型
        RentType : [
            {"enumValue":0,"enumText":"单身"},{"enumValue":2,"enumText":"家庭"}
        ],
        // 产权性质
        BuildingPropertyType : [
            {"enumValue":0,"enumText":"直管公房"},{"enumValue":1,"enumText":"系统公房"},{"enumValue":2,"enumText":"购产权房"},{"enumValue":3,"enumText":"租赁私房"},{"enumValue":4,"enumText":"自有房"},{"enumValue":5,"enumText":"其他房"}
        ],
        // 房屋类型
        CityHousingType : [
            {"enumValue":0,"enumText":"老式公寓"},{"enumValue":1,"enumText":"花园住宅"},{"enumValue":2,"enumText":"新里"},{"enumValue":3,"enumText":"高层成套"},{"enumValue":4,"enumText":"多层成套"},{"enumValue":5,"enumText":"多层不成套"},{"enumValue":6,"enumText":"旧里及非改居"},{"enumValue":7,"enumText":"简屋"},{"enumValue":8,"enumText":"两万户新工房"},{"enumValue":9,"enumText":"其他"}
        ],
        // 退租原因
        CheckOutReason : [
            {"enumValue":1,"enumText":"离职"},{"enumValue":2,"enumText":"工作调动"},{"enumValue":3,"enumText":"结婚"},{"enumValue":4,"enumText":"嘉定地区购房"},{"enumValue":5,"enumText":"其他"}
        ],
    }
}